<template>
  <div class="edit-drawer">
    <iframe class="iframe" :src="url"></iframe>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getFreeLink } from '@/api/wenjuan/publish'
import { getStore } from '@dygc/shared'
import { getAnswerIdByPhone } from '@/api/more-app/investigator-base'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'InvestigatorEditDrawer',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      url: '',
      answerId: ''
    }
  },
  watch: {
    phone(n) {
      this.getUrl()
    }
  },
  methods: {
    async getUrl() {
      await getAnswerIdByPhone({ investigatorPhone: this.phone }).then(res => {
        this.answerId = res.data.data
      })
      const surveyId = GlobalConfig.getSurveyId()
      const params = {
        channelType: '0',
        surveyId
      }
      const {
        data: { data }
      } = await getFreeLink(params)
      this.answerChannelId = data[0].id
      const origin = getSurveyDomain()
      const tenantId = GlobalConfig.getTenantId()
      const token = GlobalConfig.getToken()
      this.url = `${origin}/pc/index.html?surveyId=${surveyId}&answerChannelId=${
        this.answerChannelId
      }&token=${token}&tenantId=${tenantId}&companyid=${GlobalConfig.getCompanyId()}&editType=investigator&id=${
        this.item.id
      }&investigatorName=${this.item.investigator_name}&investigatorPhone=${this.item.investigator_phone}#/investigator-edit/${
        this.answerId
      }`
    },
    getPostMessage(msg) {
      let data = JSON.parse(msg.data)
      if (data.message === 'closeEdit') {
        this.$emit('close-drawer')
      } else if (data.message === 'reload') {
        this.url = ''
        this.getUrl()
      }
    }
  },
  mounted() {
    this.getUrl()
    window.addEventListener('message', this.getPostMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.getPostMessage)
  }
}
</script>

<style scoped lang="scss">
.edit-drawer {
  @apply h-full w-full;
  .iframe {
    width: 100%;
    height: calc(100% - 2px);
  }
}
</style>
